import React from 'react';

interface Props {
  balanceTitle: string,
  balanceText: string,
  isLoading?: boolean
} 

const BalanceEnquiryPreview = ({ balanceTitle, balanceText, isLoading}:Props) => {

    return (
      <div className='ml-10 relative'>
        <div className={`${isLoading && "bg-gray-300 opacity-30"} absolute h-full w-full`}></div>
        <div className="shadow-md flex text-left bg-white justify-left flex-col px-8">
          <p className='mt-4 mb-3 text-2xl'>{balanceTitle}</p>
          <div className="w-96 text-sm font-monospace">
            <div className='flex justify-between'>
             <p>Card Number</p>
             <p>******1234567890</p>
            </div>
            <div className='flex justify-between'>
             <p>Card Status</p>
             <p>In Use</p>
            </div>
            <div className='flex justify-between'>
             <p>Remaining Balance</p>
             <p>$124.70</p>
            </div>
            <div className='flex justify-between'>
             <p>Expiry Date</p>
             <p>October 19, 2025</p>
            </div>
          </div>
          <div className="my-4 text-sm italic text-gray-600">
          {balanceText.split(/\r?\n/).map((line, index) => (
              <React.Fragment key={index}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    )
}

export default BalanceEnquiryPreview
